
import logo from './assets/logo_futura.png';
import { useState } from 'react';
import { Link } from "react-router-dom";

function Header() {
	const [isActive, setIsActive] = useState(false)
	return (
		<>
			<header className="main-header">
				<div className="container">
					<div className="header-icon-bar animation" onClick={() => setIsActive(!isActive)}>
						<span></span>
						<span></span>
						<span></span>
					</div>
					<div className="mh-logo">
						<Link to="/"><img src={logo} className="logo" alt="Logo Futura" /></Link>
					</div>

					<div className="main-nav">
						<ul className={isActive ? "is-open ani-open" : "header-menu animation"}>
							<li className="header-menu-items">
								<Link to="/"><p>Home</p></Link>
							</li>
							<li className="header-menu-items">
								<a target="_blank" href="https://futura4me.com"><p>Chi siamo</p></a>
							</li>
							<li className="header-menu-items">
								<Link to="/servizi"><p>Servizi</p></Link>

							</li>
							<li className="header-menu-items">
								<Link to="/lavora-con-noi"><p>Lavora con noi</p></Link>
							</li>


						</ul>
					</div>
				</div>
			</header>

		</>

	);
}

export default Header;
